
export default {
  name: 'BlockExpandableLinkStandardTab',
  components: {
    BlockImagesText: () => import('~/components/cms/custom/BlockImagesText/BlockImagesText.vue'),
    BlockSimpleTabContainer: () => import('~/components/cms/custom/BlockSimpleTabContainer.vue'),
    BlockIconLabeledLinks: () => import('~/components/cms/custom/BlockIconLabeledLinks.vue'),
    BlockDownloadableFiles: () => import('~/components/cms/custom/BlockDownloadableFiles.vue'),
  },
  props: {
    title: String,
    content: {
      type: Array,
      default: () => [],
    },
  },
};
